// extracted by mini-css-extract-plugin
export var optionGrid = "_7x-7";
export var optionList = "_7x-6";
export var questionsBlock = "_7x-9";
export var spacer = "_7x-5";
export var stepCenteredContent = "_7x-3";
export var stepInner = "_7x-0";
export var stepInnerFullWidth = "_7x-1";
export var stepInnerLockScroll = "_7x-2";
export var stepTransitionFrame = "_7x-4";
export var welcomeBlock = "_7x-8";